import { useEffect, useState } from "react";
import { getDayDetail } from "../services/drinkService";

function formatDateLabel(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
}

export default function DayDetailModal({ date, amiId, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    getDayDetail(date, amiId)
      .then((d) => { if (active) setData(d); })
      .catch(() => { if (active) setError("Impossible de charger le détail de cette journée"); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [date, amiId]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="card modal-content modal-content-small" onClick={(e) => e.stopPropagation()}>
        <button className="btn-ghost modal-close" onClick={onClose}>Fermer ✕</button>
        <h4 className="day-detail-title">{formatDateLabel(date)}</h4>

        {loading && <p className="muted">Chargement...</p>}
        {error && <p className="error">{error}</p>}

        {data && !loading && (
          data.verres.length === 0 ? (
            <p className="muted">Rien bu ce jour-là 🙌</p>
          ) : (
            <ul className="day-detail-list">
              {data.verres.map((v) => (
                <li key={v.id}>
                  <span className="day-detail-heure">{v.heure.slice(0, 5)}</span>
                  <span>{v.alcool_nom}</span>
                </li>
              ))}
            </ul>
          )
        )}
      </div>
    </div>
  );
}